import { obterContaParaRecebimento } from "../../services/cliente";
import { obterDadosUsuario2 } from "../../services/cookies";
import React from "react";
import { executarRequisicaoAutenticada, SessaoExpiradaError } from "../../services/authenticatedRequest";



export const pegarFormasDePagamento = async (setListaDeFormasDePagamento: React.Dispatch<any[]>, setErro: React.Dispatch<any>, setDesconectar: React.Dispatch<any>, setLoading: React.Dispatch<boolean>) => {
    const { id } = obterDadosUsuario2()
    setLoading(true)
    setErro(false)

    if (!id) {
        setDesconectar(true)
        setLoading(false)
        return
    }

    try {
        const res = await executarRequisicaoAutenticada((token) => obterContaParaRecebimento(id, token))
        const formasDePagamento = res.data.resultado.contas
        setListaDeFormasDePagamento(formasDePagamento)
    } catch (error) {
        if (error instanceof SessaoExpiradaError) {
            setDesconectar(true)
        } else {
            setErro(true)
        }
    } finally {
        setLoading(false)
    }

}
